import React, { useState } from 'react';
import ImagePath from 'app/utilities/imagePath';
import Stepper from '../Stepper/Stepper';
import { AccordionInterface } from '../../interfaces/accordion/accrodion.interface';
import './Accordion.scss';

const Accordion = function init(props: AccordionInterface): React.ReactElement {
    const [isActive, setIsActive] = useState(false);
    const {
        stepper,
        title,
        imageSrc,
        imageAlt,
        content
    }: AccordionInterface = props;

    return (
        <div className="accordion-item">
            <div className="accordion">
                <button type="button" className={isActive ? "content-opened" : "section-root"} onClick={() => setIsActive(!isActive)}>
                    <div className="accordion-logo">
                        <img
                            src={imageSrc}
                            alt={imageAlt}
                        />
                    </div>
                    <div className="accordion-title">{title}</div>
                    <div className="accordion-chevron">
                        <img
                            src={isActive ? ImagePath.chevronUp.src : ImagePath.chevronDown.src}
                            alt={isActive ? ImagePath.chevronDown.alt : ImagePath.chevronDown.alt}
                        />
                    </div>
                </button>
                {stepper && isActive ? <Stepper content={content} /> : isActive && <p>CONTENT WITHOUT STEPPER</p>}
            </div>
        </div>
    );
};

export default Accordion;
